import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const HowItWorks = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section id="how" className="bg-slate-50 py-20 md:py-28 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t.day.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t.day.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {t.day.steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl p-7 shadow-lg hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-700 flex items-center justify-center text-3xl shadow-md">
                {step.icon}
              </div>
              <div className="text-sm font-bold uppercase tracking-wider text-indigo-600 mb-2">
                {step.time}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
